export const instructions = `
<p class="text-center fw-bold">INSTRUCTIONS</p>
<div class="d-flex justify-content-start mb-3">
    <div class="fs-5 me-2 section-no">1.</div>
    <div>
        <p><strong>This information will be kept confidential and it will NOT be shared with the Bureau of Prisons.</strong> If you have any questions or concerns about the confidentiality of your responses, please contact Class Counsel Heidi Burakiewicz who represented the veterans in this case by email at <a class="text-break text-decoration-none" href="mailto:VeteransDiscriminationCase@bdlawdc.com"><i class="bi bi-envelope"></i> VeteransDiscriminationCase@bdlawdc.com</a> or by phone at <a class="text-decoration-none" href="tel:+1-202-856-7500"><i class="bi bi-telephone"></i> 202-856-7500</a>.</p>
    </div>
</div>
<div class="d-flex justify-content-start mb-3">
    <div class="fs-5 me-2 section-no">2.</div>
    <div>
        <p><strong>You must sign the Claim Form and submit it by November 7, 2025.</strong>  We strongly urge you to fill out the form online, as this is the only way to ensure that your form does not get lost and that your entries are accurate!  The website is encrypted and secure.</p>
        <p><strong>If you are filling out the form online</strong>, you do not need to fill out the form all at once.  You will receive an email confirmation that your form has been received.  </p>
        <p><strong>If you are filling out the paper form, it will be your responsibility to ensure that the Claims Administrator receives your form.</strong> You must return the form to the Claims Administrator by email, or U.S. mail:</p>
        <p class="text-center">
            Bamford Class Action<br>
            Claims Administrator<br>
            c/o Angeion Group <br>
            Attn: Claim Forms<br>
            1650 Arch Street, Suite 2210<br>
            Philadelphia, PA 19103<br>
            Phone number: (888) 443-4193<br>
            info@VeteransDiscriminationCase.com
        </p>
    </div>
</div>
<div class="d-flex justify-content-start mb-3">
    <div class="fs-5 me-2 section-no">3.</div>
    <div>
        <p><strong>There are five sections to the Claim Form.</strong> The five sections of the Claim Form are:  </p>
        <ol type="I">
            <li>Contact Information </li>
            <li>Certification that you are a Veteran with a 30% Disability Rating or Higher</li>
            <li>Certification that the Federal Bureau of Prisons Withdrew Your Conditional Job Offer or Terminated Your Employment between August 20, 2018, and June 17, 2025, because of its Policy or Practice of Denying Employment to Veterans with a 30% Disability Rating or Higher</li>
            <li>Certification that you Suffered Harm as a Result of the BOP’s Decision to Withdraw Your Conditional Job Offer or Terminate Your Employment</li>
            <li>Your Contributions to this Case</li>
        </ol>
        <p>If you submit the form online, then you will be directed past questions that do not apply to you based on your previous answers in an effort to make the process of filling out the form quicker.  </p>
    </div>
</div>
<div class="d-flex justify-content-start mb-3">
    <div class="fs-5 me-2 section-no">4.</div>
    <div>
        <p><strong class="fst-italic">You must answer all of the required questions.</strong> Any information marked with an <span class="text-danger">*</span> is required.</p>
        <div class="callout callout-warning fw-bold">You will NOT receive any money from the settlement if you do not answer ALL of the required questions.</div>
    </div>
</div>
<div class="d-flex justify-content-start mb-3">
    <div class="fs-5 me-2 section-no">5.</div>
    <div>
        <p><strong>You should provide as much detail as possible.</strong>  The answers you provide to the questions on the Claim Form will determine whether you meet the minimum qualifications to receive money from the settlement and how much money you will receive.  Even if you have answered all of the required questions, the Claims Administrator may determine that you do not meet the minimum qualifications.  As a result, <strong>it is very important that you provide as much detail as possible</strong>.  </p>
    </div>
</div>
<div class="d-flex justify-content-start mb-3">
    <div class="fs-5 me-2 section-no">6.</div>
    <div>
        <p><strong>You must answer truthfully.</strong>  It is not possible to remember everything that has happened to you over the course of many years.  For example, you may not remember what medical information the BOP required you to provide.  <strong>If you do not know the exact answer to any question, you should provide your best estimate or average.</strong></p>
    </div>
</div>
<div class="d-flex justify-content-start mb-3">
    <div class="fs-5 me-2 section-no">7.</div>
    <div>
        <p><strong>You should contact the attorneys who represented the veterans in the case if you have any questions.</strong>  You can reach them by email at VeteransDiscriminationCase@bdlawdc.com or by phone at 202-856-7500.  You should NOT contact the Agency or the Judge with any questions about this Claim Form.</p>
    </div>
</div>`;
